<template>
	<div>
		<svg class="shelf" x="0px" y="0px" viewBox="0 0 300 50">
			<g>
				<polygon class="st0"
					points="34.29,13.42 46.62,35.88 267.58,35.57 271.77,23.18 258.33,0 258.33,8.11 		" />
				<polygon class="st1" points="34.29,13.42 47.85,30.37 55.74,30.37 52.99,12.9 		" />
				<polygon class="st1" points="252.03,13.42 238.47,30.37 230.58,30.37 233.32,12.9 		" />
				<polygon class="st1" points="230.58,30.37 229.17,25.9 230.58,13.42 233.24,13.42 		" />
				<polygon class="st1" points="55.74,30.37 58,26.74 58,13.42 53.07,13.42 		" />
				<polygon class="st2" points="39.37,19.78 54.37,21.63 52.99,12.9 34.29,13.42 		" />
				<polygon class="st2"
					points="232.22,19.93 242.49,25.34 252.03,13.42 233.24,13.42 230.58,13.42 230.22,16.64 		" />
				<rect x="28.23" class="st3" width="230.1" height="13.42" />
				<polygon class="st4" points="28.23,13.42 28.23,0 258.33,0 258.33,1.4 29.72,1.43 			" />
				<polygon class="st5" points="32.4,1.43 32.4,11.86 72.9,11.86 73.89,1.43 			" />
				<polygon class="st5" points="75.81,1.43 75.81,11.86 83.11,11.86 84.54,1.42 			" />
				<polygon class="st6" points="243.45,1.62 243.45,11.08 38.07,13.31 256.32,12.89 256.32,1.43 			" />
				<polygon class="st0" points="28.23,13.42 171.21,12.9 171.21,2.95 173.27,11.86 220.11,11.68 222.51,6.64 222.51,11.3 
		258.33,13.42 	" />
			</g>
		</svg>
	</div>
</template>

<script>
  export default {
	name: 'shelf'
  }
</script>

<style scoped>
.shelf {
	position: fixed;
	width: 48vw;
	top: 60vh;
	left: 13vw;
}

.st0{opacity:0.65;fill:#313131;enable-background:new    ;}
	.st1{fill:#42151F;}
	.st2{opacity:0.38;fill:#313131;enable-background:new    ;}
	.st3{fill:#8C3516;}
	.st4{fill:#FFFFFF;}
	.st5{opacity:0.53;fill:#FFFFFF;enable-background:new    ;}
	.st6{opacity:0.23;fill:#313131;enable-background:new    ;}
</style>
